export const MyBusinessRoutes = {
  Transactions: '/operations/my-business/transactions',
  Adjustments: '/operations/my-business/adjustments',
};
